/**
 * ZM • Style Submit Cleaner • Final Clean Checkout Version
 *
 * 目标：
 * 1. 勾选 Digital Download 后，Background 仍然能正常显示
 * 2. 删除原始复杂 Background 字段，避免 cart / checkout 重复
 * 3. 只保留一个简洁字段：properties[Background]
 * 4. 不碰 Digital File Download 的拆分逻辑
 */

(function () {
  if (window.ZMStyleSubmitCleaner) return;

  function normalizeText(v) {
    return String(v || '').replace(/\s+/g, ' ').trim();
  }

  function cleanBackgroundValue(rawValue) {
    const value = normalizeText(rawValue);

    // 例：
    // "White Matte / Dusty Blue" -> "Dusty Blue"
    // "Black Matte / Warm Gray"  -> "Warm Gray"
    if (!value.includes('/')) return value;

    const parts = value.split('/').map(s => normalizeText(s)).filter(Boolean);
    if (parts.length < 2) return value;

    return parts[parts.length - 1];
  }

  function extractPropertyLabel(key) {
    const m = String(key || '').match(/^properties\[(.+)\]$/i);
    return m ? m[1] : key;
  }

  function isAnyBackgroundLikeKey(key) {
    const k = normalizeText(key).toLowerCase();
    return k.startsWith('properties[background');
  }

  function looksLikeDigitalField(key, value) {
    const text = normalizeText(`${key} ${value}`).toLowerCase();
    return (
      text.includes('digital') ||
      text.includes('download') ||
      text.includes('artwork')
    );
  }

  function scoreBackgroundCandidate(key, value) {
    const raw = normalizeText(value);
    const label = extractPropertyLabel(key);

    let score = 0;

    if (isAnyBackgroundLikeKey(key)) score += 10;

    // 有 "/" 的优先级最高，通常是 “材质 / 背景色”
    if (raw.includes('/')) score += 20;

    // 明显 digital 干扰项降权
    if (looksLikeDigitalField(key, raw)) score -= 15;

    if (raw.length >= 3) score += 2;

    return {
      key,
      label,
      rawValue: raw,
      cleanValue: cleanBackgroundValue(raw),
      score
    };
  }

  function pickBestBackground(entries) {
    const candidates = [];

    entries.forEach(([key, value]) => {
      if (value instanceof File) return;

      const raw = normalizeText(value);
      if (!raw) return;

      if (!isAnyBackgroundLikeKey(key)) return;

      candidates.push(scoreBackgroundCandidate(key, value));
    });

    if (!candidates.length) return null;

    candidates.sort((a, b) => b.score - a.score);
    return candidates[0];
  }

  function clean(formData) {
    if (!(formData instanceof FormData)) return formData;

    const entries = Array.from(formData.entries());
    const picked = pickBestBackground(entries);

    if (!picked) return formData;

    // 先删除所有原始复杂 Background 字段
    entries.forEach(([key]) => {
      if (isAnyBackgroundLikeKey(key)) {
        formData.delete(key);
      }
    });

    // 再统一写入一个干净字段
    formData.set('properties[Background]', picked.cleanValue);

    // 保留原始值给后台排查 / 识别
    formData.set('properties[_zm_background_raw]', picked.rawValue);
    formData.set('properties[_zm_background_group]', picked.label);

    return formData;
  }

  window.ZMStyleSubmitCleaner = {
    clean,
    cleanBackgroundValue
  };
})();


// 调整购物车属性顺序：Background -> Name -> Upload Photo 前面
function reorderCartProperties() {
  const groups = document.querySelectorAll(
    '.product-option, .cart-item__property, .line-item-property'
  );

  groups.forEach(container => {
    const parent = container.parentElement;
    if (!parent) return;

    const siblings = Array.from(parent.children);

    const getText = (el) =>
      (el.textContent || '').replace(/\s+/g, ' ').trim();

    const backgroundEl = siblings.find(el => {
      const text = getText(el);
      return /^Background\s*:/.test(text);
    });

    const nameEl = siblings.find(el => {
      const text = getText(el);
      return text.includes('Name:');
    });

    const uploadEl = siblings.find(el => {
      const text = getText(el);
      return text.includes('Upload Photo');
    });

    if (nameEl && uploadEl) {
      parent.insertBefore(nameEl, uploadEl);
    }

    if (backgroundEl && nameEl) {
      parent.insertBefore(backgroundEl, nameEl);
    } else if (backgroundEl && uploadEl) {
      parent.insertBefore(backgroundEl, uploadEl);
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  setTimeout(reorderCartProperties, 200);
});








